import axios from "axios";
import { environment } from './environment'
import { saveAs } from 'file-saver';
const endpoint = environment.serverUrl;

export async function MetaobjectDefinitions(shopUrl) {
    return axios
    .get(endpoint+'/api/Metaobject/metaobject-definitions?storeUrl=' + shopUrl)
    .then(function(response) {
      if (response.status === 200 && response != null) {
        var data = response.data
        return data
      } else {
        throw new Error('Empty data')
      }
    })
    .catch(function(error) {
      console.log(error)
      return []
    })
  }

  export async function MetaobjectFields(shopUrl,type) {
    return axios
    .get(endpoint+'/api/Metaobject/metaobject-fields?storeUrl=' + shopUrl + '&type=' + type)
    .then(function(response) {
      if (response.status === 200 && response != null) {
        var data = response.data
        return data
      } else {
        throw new Error('Empty data')
      }
    })
    .catch(function(error) {
      console.log(error)
      return []
    })
  }

  export async function downloadMetaobjectBulkResult(storeUrl,bulkId,type) {
    try {
      const response = await axios.get(endpoint+"/api/Metaobject/download-bulk-result?storeUrl=" +storeUrl + "&bulkId="+bulkId +"&type=" + type, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "text/plain" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "result-"+storeUrl+"-"+type+".csv");
      document.body.appendChild(link);
      link.click();
    } catch (error) {
        console.error(error);
    }
  };

  export async function metaobjectBulkCancel(storeUrl,bulkId) {
    return await axios
        .post(endpoint+"/api/Metaobject/bulk-cancel?storeUrl=" +storeUrl + "&bulkId="+bulkId)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return []
        })
}

export async function MetaobjectBulkPolling(storeUrl) {
    return await axios
        .get(endpoint + '/api/Metaobject/bulk-polling?storeUrl='+ storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

export async function DeleteMetaobjectLogs(storeUrl) {
    return await axios
        .delete(endpoint+'/api/Metaobject/delete-older-logs?storeUrl=' +storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return []
        })   
}

export async function getMetaobjectImportHistory(storeUrl,pageNo, pageSize) {
    return await axios
        .get(endpoint + '/api/Metaobject/import-logs?storeUrl='+ storeUrl + '&pageNo='+pageNo + '&pageSize='+pageSize)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

export async function metaobjectExportStatus(storeUrl) {
    return await axios
        .get(endpoint + '/api/Metaobject/export-status?storeUrl='+storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}
